<!--  -->
<template>
  <div class="popup-container">
      <van-popup v-bind="$attrs" v-on="$listeners">
        <div class="popup__title">{{$t('homePage.joinTheCommunity')}}</div>
        <div class="popup__content">
          <div class="popup__content__text">{{$t('homePage.joinCommunityDesc')}}</div>
        </div>
        <div class="popup__communities">
          <div class="popup__community">
            <a href="https://twitter.com/MalFinance" target="_blank">
              <div class="popup__community--icon twitter" ></div>
            </a>
            <div class="popup__community__name">Twitter</div>
          </div>
          <div class="popup__community">
            <a href="https://t.me/mal_io" target="_blank">
              <div class="popup__community--icon telegram"></div>
            </a>
            <div class="popup__community__name">Telegram</div>
          </div>
          <div class="popup__community">
            <a href="https://youtube.com/channel/UCChWLjFpifD4L1oymW0NBZQ" target="_blank">
              <div class="popup__community--icon youtube"></div>
            </a>
            <div class="popup__community__name">Youtube</div>
          </div>
          <div class="popup__community">
            <a href="http://tiktok.com/@mal.io1" target="_blank">
              <div class="popup__community--icon tiktok"></div>
            </a>
            <div class="popup__community__name">Tik Tok</div>
          </div>
        </div>


      </van-popup>
    </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  props: {},
  components: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang='stylus' scoped>
iconTwitter  = '~@/assets/images/home/icon-twitter.png'
iconTelegram  = '~@/assets/images/home/icon-telegram.png'
iconYoutube  = '~@/assets/images/home/icon-youtube.png'
iconTiktok  = '~@/assets/images/home/icon-tiktok.png'
iconTwitterHover  = '~@/assets/images/home/twitter-hover.svg'
iconTelegramHover = '~@/assets/images/home/telegram-hover.svg'
iconYoutubeHover  = '~@/assets/images/home/youtube-hover.svg'
iconTiktokHover  = '~@/assets/images/home/tiktok-hover.svg'
.van-popup {
  padding: 16px 40px 24px;
  box-sizing: border-box;
  width: 364px;
  border-radius: 5px;
}

.popup__title {
  font-size: 18px;
  color: #000000;
  font-weight: 500;
  margin-bottom: 19px;
}

.popup__communities {
  display: flex;
  align-items:center;
  justify-content: space-between;
  margin-top: 32px;
}

.popup__community {
  cursor: pointer;
  img {
    width: 36px;
    height: 36px;
  }

  &--icon {
    width: 36px;
    height: 36px;
    background-position: top center;
    background-size: contain;
    background-repeat: no-repeat;

  }
  .twitter {
    background-image: url(iconTwitterHover);
    &:hover {
      background-image: url(iconTwitterHover);
    }
  }
  .telegram {
    background-image: url(iconTelegramHover);
    &:hover {
      background-image: url(iconTelegramHover);
    }
  }
  .youtube {
    background-image: url(iconYoutubeHover);
    &:hover {
      background-image: url(iconYoutubeHover);
    }
  }
  .tiktok {
    background-image: url(iconTiktokHover);
    &:hover {
      background-image: url(iconTiktokHover);
    }
  }

  &__name {
    font-size: 12px;
    font-weight: 500;
    color: #000000;
    margin-top: 8px;
  }
}

.popup__footer {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.popup__left__btn,
.popup__right__btn {
  flex: 0 0 134px;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.popup__left__btn {
  border-radius: 4px;
  border: 1px solid #000000;
  font-size: 14px;
  color: #000;
}

.popup__right__btn {
  background: #0CC267;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
}


.popup-nft__pics {
  display: flex;
  align-items: center;

  &--item {
    flex: 0 0 64px;
    height: 64px;
    margin-right: 12px;
    background: #999;
  }
}

.popup-nft__desc {
  font-size: 14px;
  font-weight: 400;
  color: #6D7278;
  line-height: 20px;
}


</style>
